import React, { ComponentProps } from "react";
import { NumericFormat } from "react-number-format";
import InputShell, { Props as InputShellProps } from "./InputShell";

type Props = {
  onChange: (newValue: string) => void;
  value: string;
} & Omit<InputShellProps, "children"> &
  Omit<ComponentProps<typeof NumericFormat>, "onChange">;

function InputNumber({ label, onChange, error, value, isOptional, ...rest }: Props) {
  const inputShell = {
    label,
    error,
    ...(isOptional
      ? { isOptional, optionalLabel: rest.optionalLabel }
      : { required: rest.required })
  };
  return (
    <InputShell {...inputShell}>
      <NumericFormat
        className="min-h-[2.5rem] w-full rounded-[0.25rem] border border-outline px-3 text-sm leading-4 focus:outline-none"
        title={label}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        autoComplete="off"
        decimalScale={2}
        thousandSeparator=","
        thousandsGroupStyle="thousand"
        {...rest}
      />
    </InputShell>
  );
}

export default InputNumber;
